/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Secrets
 * API for managing Secrets on Cloud Services.
 *
 * The version of the OpenAPI document: 2023-11-28
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ApiHttpBodyFromJSON, SecretServiceConnectGitHubInstallationBodyToJSON, SecretServiceCreateAppBodyToJSON, SecretServiceCreateAppKVSecretBodyToJSON, SecretServiceCreateAwsDynamicSecretBodyToJSON, SecretServiceCreateAwsIntegrationBodyToJSON, SecretServiceCreateAwsSmSyncIntegrationBodyToJSON, SecretServiceCreateAzureKvSyncIntegrationBodyToJSON, SecretServiceCreateGatewayPoolBodyToJSON, SecretServiceCreateGcpDynamicSecretBodyToJSON, SecretServiceCreateGcpIntegrationBodyToJSON, SecretServiceCreateGcpSmSyncIntegrationBodyToJSON, SecretServiceCreateGhOrgSyncIntegrationBodyToJSON, SecretServiceCreateGhRepoSyncIntegrationBodyToJSON, SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON, SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON, SecretServiceCreateTwilioIntegrationBodyToJSON, SecretServiceCreateTwilioRotatingSecretBodyToJSON, SecretServiceCreateVercelProjectSyncIntegrationBodyToJSON, SecretServiceForceSyncBodyToJSON, SecretServiceSetTierBodyToJSON, SecretServiceUpdateAppBodyToJSON, SecretServiceUpsertSyncInstallationBodyToJSON, Secrets20231128ConnectGitHubInstallationResponseFromJSON, Secrets20231128CreateAppKVSecretResponseFromJSON, Secrets20231128CreateAppResponseFromJSON, Secrets20231128CreateAwsDynamicSecretResponseFromJSON, Secrets20231128CreateAwsIntegrationResponseFromJSON, Secrets20231128CreateGatewayPoolResponseFromJSON, Secrets20231128CreateGcpDynamicSecretResponseFromJSON, Secrets20231128CreateGcpIntegrationResponseFromJSON, Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON, Secrets20231128CreateSyncIntegrationResponseFromJSON, Secrets20231128CreateTwilioIntegrationResponseFromJSON, Secrets20231128CreateTwilioRotatingSecretResponseFromJSON, Secrets20231128GetAppResponseFromJSON, Secrets20231128GetAppSecretResponseFromJSON, Secrets20231128GetAppSecretVersionResponseFromJSON, Secrets20231128GetAwsDynamicSecretResponseFromJSON, Secrets20231128GetAwsIntegrationResponseFromJSON, Secrets20231128GetGcpDynamicSecretResponseFromJSON, Secrets20231128GetGcpIntegrationResponseFromJSON, Secrets20231128GetGitHubEnvironmentsResponseFromJSON, Secrets20231128GetGitHubInstallLinksResponseFromJSON, Secrets20231128GetGitHubRepositoriesResponseFromJSON, Secrets20231128GetIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON, Secrets20231128GetRotatingSecretStateResponseFromJSON, Secrets20231128GetSyncInstallationResponseFromJSON, Secrets20231128GetSyncIntegrationResponseFromJSON, Secrets20231128GetTwilioIntegrationResponseFromJSON, Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON, Secrets20231128GetUsageResponseFromJSON, Secrets20231128GetVercelInstallationLinkResponseFromJSON, Secrets20231128ListAppSecretVersionsResponseFromJSON, Secrets20231128ListAppSecretsResponseFromJSON, Secrets20231128ListAppsResponseFromJSON, Secrets20231128ListAwsDynamicSecretsResponseFromJSON, Secrets20231128ListAwsIntegrationsResponseFromJSON, Secrets20231128ListGcpDynamicSecretsResponseFromJSON, Secrets20231128ListGcpIntegrationsResponseFromJSON, Secrets20231128ListGitHubInstallationsResponseFromJSON, Secrets20231128ListIntegrationsResponseFromJSON, Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON, Secrets20231128ListOpenAppSecretVersionsResponseFromJSON, Secrets20231128ListSyncInstallationsResponseFromJSON, Secrets20231128ListSyncIntegrationsResponseFromJSON, Secrets20231128ListTwilioIntegrationsResponseFromJSON, Secrets20231128OpenAppSecretResponseFromJSON, Secrets20231128OpenAppSecretVersionResponseFromJSON, Secrets20231128OpenAppSecretsResponseFromJSON, Secrets20231128UpdateAppResponseFromJSON, Secrets20231128UpsertSyncInstallationResponseFromJSON, } from '../models';
/**
 *
 */
export class SecretServiceApi extends runtime.BaseAPI {
    /**
     */
    async completeGitHubInstallRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        if (requestParameters.installationId !== undefined) {
            queryParameters['installation_id'] = requestParameters.installationId;
        }
        if (requestParameters.setupAction !== undefined) {
            queryParameters['setup_action'] = requestParameters.setupAction;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/sync/github/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => ApiHttpBodyFromJSON(jsonValue));
    }
    /**
     */
    async completeGitHubInstall(code, state, installationId, setupAction) {
        const response = await this.completeGitHubInstallRaw({ code: code, state: state, installationId: installationId, setupAction: setupAction });
        return await response.value();
    }
    /**
     */
    async completeVercelInstallationRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        if (requestParameters.configurationId !== undefined) {
            queryParameters['configuration_id'] = requestParameters.configurationId;
        }
        if (requestParameters.teamId !== undefined) {
            queryParameters['team_id'] = requestParameters.teamId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/sync/vercel/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => ApiHttpBodyFromJSON(jsonValue));
    }
    /**
     */
    async completeVercelInstallation(code, state, configurationId, teamId) {
        const response = await this.completeVercelInstallationRaw({ code: code, state: state, configurationId: configurationId, teamId: teamId });
        return await response.value();
    }
    /**
     */
    async connectGitHubInstallationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling connectGitHubInstallation.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling connectGitHubInstallation.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling connectGitHubInstallation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/github/installations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceConnectGitHubInstallationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ConnectGitHubInstallationResponseFromJSON(jsonValue));
    }
    /**
     */
    async connectGitHubInstallation(organizationId, projectId, body) {
        const response = await this.connectGitHubInstallationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async createApp(organizationId, projectId, body) {
        const response = await this.createAppRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAppKVSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppKVSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secret/kv`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppKVSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppKVSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAppKVSecret(organizationId, projectId, appName, body) {
        const response = await this.createAppKVSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsIntegration(organizationId, projectId, body) {
        const response = await this.createAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsSmSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsSmSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsSmSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsSmSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/aws-sm`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsSmSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsSmSyncIntegration(organizationId, projectId, body) {
        const response = await this.createAwsSmSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAzureKvSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAzureKvSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAzureKvSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAzureKvSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/azure-kv`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAzureKvSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAzureKvSyncIntegration(organizationId, projectId, body) {
        const response = await this.createAzureKvSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     * Gateways
     */
    async createGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGatewayPoolBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     * Gateways
     */
    async createGatewayPool(organizationId, projectId, body) {
        const response = await this.createGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpIntegration(organizationId, projectId, body) {
        const response = await this.createGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpSmSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpSmSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpSmSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpSmSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/gcp-sm`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpSmSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpSmSyncIntegration(organizationId, projectId, body) {
        const response = await this.createGcpSmSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGhOrgSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGhOrgSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGhOrgSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGhOrgSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/gh-org`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGhOrgSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGhOrgSyncIntegration(organizationId, projectId, body) {
        const response = await this.createGhOrgSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGhRepoSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGhRepoSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGhRepoSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGhRepoSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/gh-repo`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGhRepoSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGhRepoSyncIntegration(organizationId, projectId, body) {
        const response = await this.createGhRepoSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasIntegration(organizationId, projectId, body) {
        const response = await this.createMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createMongoDBAtlasRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioIntegration(organizationId, projectId, body) {
        const response = await this.createTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createTwilioRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createVercelProjectSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createVercelProjectSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createVercelProjectSyncIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createVercelProjectSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/vercel-project`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateVercelProjectSyncIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createVercelProjectSyncIntegration(organizationId, projectId, body) {
        const response = await this.createVercelProjectSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async deleteAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteApp(organizationId, projectId, name) {
        const response = await this.deleteAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.deleteAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.deleteAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async deleteAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsIntegration(organizationId, projectId, name) {
        const response = await this.deleteAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpIntegration(organizationId, projectId, name) {
        const response = await this.deleteGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.integrationName === null || requestParameters.integrationName === undefined) {
            throw new runtime.RequiredError('integrationName', 'Required parameter requestParameters.integrationName was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{integration_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"integration_name"}}`, encodeURIComponent(String(requestParameters.integrationName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteMongoDBAtlasIntegration(organizationId, projectId, integrationName, name) {
        const response = await this.deleteMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, integrationName: integrationName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteSyncInstallationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteSyncInstallation.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteSyncInstallation.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteSyncInstallation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/installations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteSyncInstallation(organizationId, projectId, name) {
        const response = await this.deleteSyncInstallationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteSyncIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteSyncIntegration.');
        }
        const queryParameters = {};
        if (requestParameters.purgeSyncedSecrets !== undefined) {
            queryParameters['purge_synced_secrets'] = requestParameters.purgeSyncedSecrets;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteSyncIntegration(organizationId, projectId, name, purgeSyncedSecrets) {
        const response = await this.deleteSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, purgeSyncedSecrets: purgeSyncedSecrets });
        return await response.value();
    }
    /**
     */
    async deleteTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.integrationName === null || requestParameters.integrationName === undefined) {
            throw new runtime.RequiredError('integrationName', 'Required parameter requestParameters.integrationName was null or undefined when calling deleteTwilioIntegration.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{integration_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"integration_name"}}`, encodeURIComponent(String(requestParameters.integrationName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteTwilioIntegration(organizationId, projectId, integrationName, name) {
        const response = await this.deleteTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, integrationName: integrationName, name: name });
        return await response.value();
    }
    /**
     */
    async forceSyncRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling forceSync.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling forceSync.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling forceSync.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/force`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceForceSyncBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async forceSync(organizationId, projectId, body) {
        const response = await this.forceSyncRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async getAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async getApp(organizationId, projectId, name) {
        const response = await this.getAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.getAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.getAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async getAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsIntegration(organizationId, projectId, name) {
        const response = await this.getAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpIntegration(organizationId, projectId, name) {
        const response = await this.getGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGitHubEnvironmentsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGitHubEnvironments.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGitHubEnvironments.');
        }
        if (requestParameters.repository === null || requestParameters.repository === undefined) {
            throw new runtime.RequiredError('repository', 'Required parameter requestParameters.repository was null or undefined when calling getGitHubEnvironments.');
        }
        const queryParameters = {};
        if (requestParameters.installationName !== undefined) {
            queryParameters['installation_name'] = requestParameters.installationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/github/repositories/{repository}/environments`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"repository"}}`, encodeURIComponent(String(requestParameters.repository))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGitHubEnvironmentsResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGitHubEnvironments(organizationId, projectId, repository, installationName) {
        const response = await this.getGitHubEnvironmentsRaw({ organizationId: organizationId, projectId: projectId, repository: repository, installationName: installationName });
        return await response.value();
    }
    /**
     */
    async getGitHubInstallLinksRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGitHubInstallLinks.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGitHubInstallLinks.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/github/links`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGitHubInstallLinksResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGitHubInstallLinks(organizationId, projectId) {
        const response = await this.getGitHubInstallLinksRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getGitHubRepositoriesRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGitHubRepositories.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGitHubRepositories.');
        }
        const queryParameters = {};
        if (requestParameters.installationName !== undefined) {
            queryParameters['installation_name'] = requestParameters.installationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/github/repositories`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGitHubRepositoriesResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGitHubRepositories(organizationId, projectId, installationName) {
        const response = await this.getGitHubRepositoriesRaw({ organizationId: organizationId, projectId: projectId, installationName: installationName });
        return await response.value();
    }
    /**
     */
    async getIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getIntegration(organizationId, projectId, name) {
        const response = await this.getIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.integrationName === null || requestParameters.integrationName === undefined) {
            throw new runtime.RequiredError('integrationName', 'Required parameter requestParameters.integrationName was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{integration_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"integration_name"}}`, encodeURIComponent(String(requestParameters.integrationName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasIntegration(organizationId, projectId, integrationName, name) {
        const response = await this.getMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, integrationName: integrationName, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfig(organizationId, projectId, appName, secretName) {
        const response = await this.getMongoDBAtlasRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getRotatingSecretStateRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getRotatingSecretState.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/rotation-state`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetRotatingSecretStateResponseFromJSON(jsonValue));
    }
    /**
     */
    async getRotatingSecretState(organizationId, projectId, appName, secretName) {
        const response = await this.getRotatingSecretStateRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getSyncInstallationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSyncInstallation.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getSyncInstallation.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getSyncInstallation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/installations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetSyncInstallationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getSyncInstallation(organizationId, projectId, name) {
        const response = await this.getSyncInstallationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getSyncIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSyncIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getSyncIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getSyncIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetSyncIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getSyncIntegration(organizationId, projectId, name) {
        const response = await this.getSyncIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.integrationName === null || requestParameters.integrationName === undefined) {
            throw new runtime.RequiredError('integrationName', 'Required parameter requestParameters.integrationName was null or undefined when calling getTwilioIntegration.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{integration_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"integration_name"}}`, encodeURIComponent(String(requestParameters.integrationName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioIntegration(organizationId, projectId, integrationName, name) {
        const response = await this.getTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, integrationName: integrationName, name: name });
        return await response.value();
    }
    /**
     */
    async getTwilioRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioRotatingSecretConfig(organizationId, projectId, appName, secretName) {
        const response = await this.getTwilioRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getUsageRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getUsage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage(organizationId, projectId) {
        const response = await this.getUsageRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getUsage2Raw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage2.');
        }
        const queryParameters = {};
        if (requestParameters.projectId !== undefined) {
            queryParameters['project_id'] = requestParameters.projectId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage2(organizationId, projectId) {
        const response = await this.getUsage2Raw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getVercelInstallationLinkRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getVercelInstallationLink.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getVercelInstallationLink.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/vercel/link`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetVercelInstallationLinkResponseFromJSON(jsonValue));
    }
    /**
     */
    async getVercelInstallationLink(organizationId, projectId) {
        const response = await this.getVercelInstallationLinkRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async listAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, name, type) {
        const response = await this.listAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, name: name, type: type });
        return await response.value();
    }
    /**
     */
    async listAppsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listApps.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listApps.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listApps(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, name) {
        const response = await this.listAppsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, name: name });
        return await response.value();
    }
    /**
     */
    async listAwsDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAwsDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAwsIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGcpDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listGcpDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGcpIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGitHubInstallationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGitHubInstallations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGitHubInstallations.');
        }
        const queryParameters = {};
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/github/installations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGitHubInstallationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGitHubInstallations(organizationId, projectId, state) {
        const response = await this.listGitHubInstallationsRaw({ organizationId: organizationId, projectId: projectId, state: state });
        return await response.value();
    }
    /**
     */
    async listIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.capabilities) {
            queryParameters['capabilities'] = requestParameters.capabilities;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, capabilities) {
        const response = await this.listIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, capabilities: capabilities });
        return await response.value();
    }
    /**
     */
    async listMongoDBAtlasIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listMongoDBAtlasIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listMongoDBAtlasIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listOpenAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listOpenAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListOpenAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listOpenAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listOpenAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listSyncInstallationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listSyncInstallations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listSyncInstallations.');
        }
        const queryParameters = {};
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/installations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListSyncInstallationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listSyncInstallations(organizationId, projectId, type) {
        const response = await this.listSyncInstallationsRaw({ organizationId: organizationId, projectId: projectId, type: type });
        return await response.value();
    }
    /**
     */
    async listSyncIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listSyncIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listSyncIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.appName !== undefined) {
            queryParameters['app_name'] = requestParameters.appName;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListSyncIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listSyncIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, appName, name, type) {
        const response = await this.listSyncIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, appName: appName, name: name, type: type });
        return await response.value();
    }
    /**
     */
    async listTwilioIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listTwilioIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listTwilioIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListTwilioIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listTwilioIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listTwilioIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async openAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.openAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async openAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling openAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.openAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async openAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, types) {
        const response = await this.openAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, types: types });
        return await response.value();
    }
    /**
     */
    async rotateSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling rotateSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}:rotate`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async rotateSecret(organizationId, projectId, appName, secretName, body) {
        const response = await this.rotateSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, body: body });
        return await response.value();
    }
    /**
     */
    async setTierRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling setTier.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling setTier.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/billing/tier`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceSetTierBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async setTier(organizationId, body) {
        const response = await this.setTierRaw({ organizationId: organizationId, body: body });
        return await response.value();
    }
    /**
     */
    async updateAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateApp(organizationId, projectId, name, body) {
        const response = await this.updateAppRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async upsertSyncInstallationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling upsertSyncInstallation.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling upsertSyncInstallation.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling upsertSyncInstallation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/sync/installations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpsertSyncInstallationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpsertSyncInstallationResponseFromJSON(jsonValue));
    }
    /**
     */
    async upsertSyncInstallation(organizationId, projectId, body) {
        const response = await this.upsertSyncInstallationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ListIntegrationsCapabilitiesEnum;
(function (ListIntegrationsCapabilitiesEnum) {
    ListIntegrationsCapabilitiesEnum["DYNAMIC"] = "DYNAMIC";
    ListIntegrationsCapabilitiesEnum["ROTATION"] = "ROTATION";
    ListIntegrationsCapabilitiesEnum["SYNC"] = "SYNC";
})(ListIntegrationsCapabilitiesEnum || (ListIntegrationsCapabilitiesEnum = {}));
